<template>
  <main>
    <trac-loading v-if="isLoading"></trac-loading>
    <div v-else>
      <h1 class="text-2xl font-bold">Merchant Visit</h1>
      <div class="flex justify-end items-end">
        <button
          class="bg-yellow-100 mr-2 py-3 px-6 rounded-md text-black"
          @click="
            $router.push({
              name: 'NewMerchantVisit',
            })
          "
        >
          New Merchant Visit
        </button>
        <button
          class="bg-blue-600 py-3 px-6 rounded-md text-white"
          @click="downloadCSV"
        >
          Download CSV
        </button>
      </div>
      <div class="flex items-center mt-10">
        <input
          type="text"
          class="inline-block px-2 ring-2 outline-none ring-blue-500 rounded-sm ml-2 w-80 text-sm py-2"
          name=""
          placeholder="Search Merchant name or support officer or business name"
          id=""
          v-model="search"
        />
        <button
          class="bg-blue-600 py-3 ml-2 px-6 rounded-md text-xs text-white"
          @click="searchRecords"
        >
          Search
        </button>
        <button
          class="bg-red-600 py-3 ml-1 px-6 rounded-md text-xs text-white"
          @click="clearSearchRecords"
        >
          Clear
        </button>
      </div>
      <div class="flex bg-blue-50 p-5 mt-10">
        <div class="flex-2 inline-block time-filter mr-2">
          <p class="">Filter By:</p>
          <select
            required
            v-model="filterType"
            class="shadow h-8 appearance-none border rounded w-full px-2 text-gray-700 mt-1 focus:outline-none focus:shadow-outline"
          >
            <option value="">Select Filter Type</option>
            <option value="filterByVisitationDate">Visitation Date</option>
            <option value="filterByVisitationAgenda">Visitation Agenda</option>
            <option value="filterByLocation">Location</option>
            <option value="filterByVisitationStatus">Visitation Status</option>
          </select>
        </div>
        <div
          class="flex-2 inline-block time-filter"
          v-if="filterType === 'filterByLocation'"
        >
          <p>Location:</p>
          <input
            type="text"
            class="inline-block border-2 h-10 px-2 rounded-sm mr-2"
            name=""
            id=""
            v-model="location"
          />
        </div>
        <div
          class="flex-2 inline-block time-filter"
          v-if="filterType === 'filterByVisitationStatus'"
        >
          <p>Visitation Status:</p>
          <select
            required
            v-model="visitationStatus"
            class="shadow h-8 appearance-none border rounded w-full px-2 text-gray-700 mt-1 focus:outline-none focus:shadow-outline"
          >
            <option value="">Select Visitation Status</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </select>
        </div>
        <div
          class="flex-2 inline-block time-filter"
          v-if="filterType === 'filterByVisitationAgenda'"
        >
          <p>Visitation Agenda:</p>
          <select
            required
            v-model="visitationAgenda"
            class="shadow h-8 appearance-none border rounded w-full px-2 text-gray-700 mt-1 focus:outline-none focus:shadow-outline"
          >
            <option value="">Select Visitation Agenda</option>
            <option value="Regular check-in">Regular check-in</option>
            <option value="Merchant Complaint">Merchant Complaint</option>
            <option value="Inactivity">Inactivity</option>
          </select>
        </div>
        <div
          class="flex-2 inline-block time-filter"
          v-if="filterType === 'filterByVisitationDate'"
        >
          <p>From:</p>
          <input
            type="date"
            class="inline-block border-2 h-10 px-2 rounded-sm mr-2"
            name=""
            id=""
            v-model="dateData.startDate"
          />
        </div>
        <div
          class="flex-2 inline-block time-filter"
          v-if="filterType === 'filterByVisitationDate'"
        >
          <p>To:</p>
          <input
            type="date"
            class="inline-block border-2 h-10 px-2 rounded-sm mr-2"
            name=""
            id=""
            v-model="dateData.endDate"
          />
        </div>
        <div class="flex mt-5 ml-5">
          <button
            @click="fetchFilteredRecords"
            class="block uppercase shadow bg-green-800 hover:bg-blue-700 focus:shadow-outline focus:outline-none text-white text-xs h-10 px-3 rounded"
          >
            Filter
          </button>
          <button
            @click="clearDateFilter"
            class="block uppercase shadow bg-red-800 hover:bg-red-700 ml-2 focus:shadow-outline focus:outline-none text-white h-10 text-xs px-3 rounded"
          >
            Reset
          </button>
          <button
            v-if="filterType === 'dateDeployed'"
            @click="downloadDatedCSV"
            class="block uppercase shadow bg-blue-800 hover:bg-blue-700 ml-2 focus:shadow-outline focus:outline-none text-white h-10 text-xs px-3 rounded"
          >
            Download
          </button>
        </div>
      </div>
      <div class="mt-14">
        <div class="mt-5" style="max-height: 600px; overflow: auto">
          <table class="shadow-lg bg-white w-full relative border-collapse">
            <tr>
              <th
                class="text-l p-3 text-left"
                colspan="13"
                style="background: #dee6f2"
              >
                Merchant Information
              </th>
            </tr>
            <tr>
              <th
                class="bg-blue-100 text-sm whitespace-nowrap text-left px-8 py-2"
              >
                Support Officer
              </th>
              <th
                class="bg-blue-100 text-sm whitespace-nowrap text-left px-8 py-2"
              >
                Merchant Name
              </th>
              <th
                class="bg-blue-100 text-sm whitespace-nowrap text-left px-8 py-2"
              >
                Business Name
              </th>
              <th
                class="bg-blue-100 text-sm whitespace-nowrap text-left px-8 py-2"
              >
                Support Cluster
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Contact Name
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Business Phone number
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Business Email Address
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Store Type
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Terminal ID
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Visitation Date
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Visitation Agenda
              </th>
              <th
                class="bg-blue-100 text-sm border whitespace-nowrap text-left px-8 py-2"
              >
                Visitation Status
              </th>
            </tr>
            <tr class="text-xs" v-for="(account, i) in filterAccounts" :key="i">
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.merchantSupportOfficer || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.merchantName || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.businessName || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.supportCluster || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.contactName || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.businessPhoneNumber || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.merchantEmail || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.store || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.terminalID || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{
                  moment(account.visitationDate, "YYYY-MM-DD").format(
                    "DD/MM/YYYY - h:mm:ss a"
                  )
                }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.visitationAgenda || "N/A" }}
              </td>
              <td class="border px-8 py-3 whitespace-nowrap text-xs">
                {{ account.status || "N/A" }}
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-3">
          <button
            @click="prevPage(currentPage)"
            :disabled="currentPage === 1 ? isDisabled : !isDisabled"
            class="uppercase shadow ml-3 hover:bg-blue-600 focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-8 rounded"
            :class="
              currentPage === 1
                ? 'bg-blue-50 text-black'
                : 'bg-blue-900 text-white'
            "
          >
            &laquo; Prev
          </button>

          <button
            @click="nextPage(currentPage)"
            class="float-right uppercase shadow ml-3 hover:bg-blue-600 bg-blue-900 focus:shadow-outline focus:outline-none text-white text-xs font-bold py-3 px-8 rounded"
            v-if="filterAccounts.length > 99"
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { json2excel } from "js2excel";
import { GET_USER_BUSINESS_DATA } from "../browser-db-config/localStorage";
import authorizedUsers from "../config/authUsers";
export default {
  data() {
    return {
      moment,
      isLoading: false,
      search: "",
      accounts: null,
      selected: [],
      selectedWhitelist: [],
      currentPage: 1,
      isDisabled: true,
      dateData: null,
      filterType: "",
      filterActive: false,
      searchActive: false,
      filterByVisitationDate: false,
      visitationStatus: "",
      visitationAgenda: "",
    };
  },
  computed: {
    ...mapGetters(["GET_SCHEDULE_MANAGEMENT"]),
    filterAccounts() {
      //let y = this.GET_DOCUMENTS.data.filter((b) => b.status === x);
      if (this.GET_SCHEDULE_MANAGEMENT.data) {
        return this.GET_SCHEDULE_MANAGEMENT.data.filter(
          (account) =>
            account.merchantEmail.includes(this.search) ||
            account.businessName.includes(this.search) ||
            account.merchantSupportOfficer
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            account.merchantName
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      } else {
        return [];
      }
      // this.documents = filtered;
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
  async mounted() {},
  async created() {
    const d = new Date();
    this.dateData = {
      startDate: new Date(d.setDate(d.getDate())).toJSON().split("T")[0],
      endDate: new Date().toJSON().split("T")[0],
      creationDate: new Date().toJSON().split("T")[0],
      startTime: "00:00",
      endTime: this.moment(d).format("HH:mm"),
    };
    this.fetchRecords();
  },
  methods: {
    async fetchRecords() {
      this.isLoading = true;
      let response = await this.$store.dispatch("FETCH_SCHEDULE_MANAGEMENT");
      this.accounts = response.data;
      this.isLoading = false;
      if (response.data) {
      }
    },
    async fetchFilteredRecords() {
      const filterType = this.filterType;
      this.filterActive = true;
      let searchActive = this.searchActive;
      let search = this.search;
      let filterParams = "";

      if (filterType === "filterByVisitationAgenda") {
        filterParams = this.visitationAgenda;
      } else if (filterType === "filterByLocation") {
        filterParams = this.location;
      } else if (filterType === "filterByVisitationStatus") {
        filterParams = this.visitationStatus;
      } else if (filterType === "filterByVisitationDate") {
        filterParams = this.dateData;
      }
      let payload = {
        // filterActive,
        filterType,
        // date: this.dateData,
        // searchActive,
        // search,
        filterParams,
      };
      this.currentPage = 1;
      if (this.filterType !== "") {
        this.filterActive = true;
        if (
          this.dateData.startDate > this.dateData.endDate ||
          (this.dateData.startDate === this.dateData.endDate &&
            filterType === "filterByVisitationDate")
        ) {
          alert(
            "Sorry, you entered an invalid date pair. Please check it and try again."
          );
        } else {
          try {
            this.isLoading = true;
            // let payload = { date: this.dateData, filterType };
            let res = await this.$store.dispatch(
              "FETCH_FILTERED_SCHEDULE_MANAGEMENT",
              payload
            );
            this.isLoading = false;
            if (res.status) {
              if (res.data === null) {
                this.isLoading = false;
                alert(
                  res.error ||
                    res.message ||
                    "Error: Please check network or contact admin."
                );
              }
              // this.fetchRecords();
            } else {
              alert(
                res.error ||
                  res.message ||
                  "Error: Please check network or contact admin."
              );
            }
          } catch (error) {}
        }
      }
    },
    clearDateFilter() {
      this.fetchRecords();
      this.currentPage = 1;
      this.filterType = "";
    },
    async downloadDatedCSV() {
      if (
        this.dateData.startDate > this.dateData.endDate ||
        this.dateData.startDate === this.dateData.endDate
      ) {
        alert(
          "Sorry, you entered an invalid date pair. Please check it and try again."
        );
      } else {
        this.isLoading = true;
        try {
          let res = await this.$store.dispatch(
            "DOWNLOAD_DATED_CSV_MERCHANT_VISITATION",
            this.dateData
          );

          this.isLoading = false;
          if (res.status == true) {
            // alert("Backlist was successful");
            window.open(res.data, "_blank");
            this.fetchRecords();
          } else {
            alert(
              res.error ||
                res.message ||
                "Error: Please check network or contact admin."
            );
          }
        } catch (error) {}
      }
    },

    async prevPage() {
      this.isLoading = true;
      let currPage = this.currentPage;
      let filterActive = this.filterActive;
      let filterType = this.filterType;
      let searchActive = this.searchActive;
      let search = this.search;
      let filterParams = "";
      if (filterType === "filterByVisitationAgenda") {
        filterParams = this.visitationAgenda;
      } else if (filterType === "filterByLocation") {
        filterParams = this.location;
      } else if (filterType === "filterByVisitationStatus") {
        filterParams = this.visitationStatus;
      } else if (filterType === "filterByVisitationDate") {
        filterParams = this.dateData;
      }
      let payload = {
        page: currPage - 1,
        filterActive,
        filterParams,
        filterType,
        date: this.dateData,
        searchActive,
        search,
      };
      let res = await this.$store.dispatch("PAGINATE_SCHEDULES_MGT", payload);
      if (res.status) {
        this.isLoading = false;
        this.currentPage -= 1;
        if (res.data === null) {
          alert(res.message);
          this.fetchRecords();
          this.currentPage = 1;
        }
      }
    },
    async nextPage() {
      this.isLoading = true;
      let currPage = this.currentPage;
      let filterActive = this.filterActive;
      let filterType = this.filterType;
      let searchActive = this.searchActive;
      let search = this.search;
      let filterParams = "";
      if (filterType === "filterByVisitationAgenda") {
        filterParams = this.visitationAgenda;
      } else if (filterType === "filterByLocation") {
        filterParams = this.location;
      } else if (filterType === "filterByVisitationStatus") {
        filterParams = this.visitationStatus;
      } else if (filterType === "filterByVisitationDate") {
        filterParams = this.dateData;
      }
      let payload = {
        filterParams,
        page: currPage + 1,
        filterActive,
        filterType,
        date: this.dateData,
        searchActive,
        search,
      };
      let res = await this.$store.dispatch("PAGINATE_SCHEDULES_MGT", payload);
      if (res.status) {
        this.isLoading = false;
        this.currentPage += 1;
        if (res.data === null) {
          alert(res.message);
          this.fetchRecords();
          this.currentPage = 1;
        }
      }
    },
    async downloadCSV() {
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch(
          "DOWNLOAD_CSV_MERCHANT_VISITATION"
        );
        this.isLoading = false;

        if (res.status) {
          // window.open(res.data, "_blank");
          alert(res.message);
          this.fetchRecords();
        } else {
          alert(
            res.error ||
              res.message ||
              "Error: Please check network or contact admin."
          );
        }
      } catch (error) {}
    },
    async searchRecords() {
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch(
          "SEARCH_SCHEDULED_MGT",
          this.search
        );

        this.isLoading = false;
        this.searchActive = true;
        if (res.status) {
          this.isLoading = false;
          if (res.data === null) {
            alert(res.message);
            this.search = "";
            this.fetchRecords();
          }
        } else {
          alert(
            res.error ||
              res.message ||
              "Error: Please check network or contact admin."
          );
        }
      } catch (error) {}
    },
    async clearSearchRecords() {
      if (this.search !== "") {
        this.search = "";
        this.fetchRecords();
        this.searchActive = false;
        this.currentPage = 1;
      }
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 350px;
}
table tr th:last-child {
  border-right: 1px solid rgb(241, 241, 241);
}
table tr th,
table tr td {
  /* border-right: 1px solid #bbb; */
  border-bottom: 1px solid rgb(238, 238, 238);
  padding: 18px;
}
table tr th:first-child,
table tr td:first-child {
  /* border-right: 1px solid rgb(223, 223, 223); */
  border-left: 1px solid rgb(241, 241, 241);
}
table tr th {
  background: rgb(255, 255, 255);
  border-top: 1px solid rgb(241, 241, 241);
  text-align: left;
  position: sticky;
  top: 0;
}
table tr td {
  background: #f0f6fd;
}
/* top-left border-radius */
table tr:first-child th:first-child {
  border-top-left-radius: 6px;
}

/* top-right border-radius */
table tr:first-child th:last-child {
  border-top-right-radius: 6px;
}

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 6px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 6px;
}
</style>
